import { postApi } from "utils/apiCall";
import { CLIENT_ID } from "constants/ApiEndPointsConstants";

// module_id "20" matches the mapping in src/components/layout-components/MenuContent.js's
// handleExternalClick (case 'employee-connect'), which mints this same
// handoff token for the old window.open flow — that flow's REACT_APP_URL_EDU
// target confirms "Employee Connect" is a MyM-only relabeling of the
// Education/Toolbox app, not a separate module.
const EMPLOYEE_CONNECT_MODULE_ID = "20";

// One step, unlike the other three modules: for module 20, MyM's
// /auto_login_app_web calls Education's own /managed_education_auto_users,
// which saves the token it returns in tbl_manage_user_token (utils/auth.js
// manageWebAccessToken). That table is exactly what ToolboxAPI's authenticate
// middleware checks, so the token MyM hands back is already a valid
// Education session token and is used directly as token-id. No second
// exchange is needed, and so no admin access key ships in the browser bundle.
// A later 401 (e.g. the user logged in elsewhere and the token was replaced)
// makes the API layer ask MyM for a fresh one.
let cachedSessionPromise = null;
// Which MyM user/client the cached session belongs to. Sign-out/sign-in
// doesn't reload the page, so without this a manager signing in after an
// admin in the same tab would keep using the admin's module session.
let cachedSessionOwner = null;
const currentSessionOwner = () => `${localStorage.getItem("user_id")}|${localStorage.getItem("client_id")}`;

const getHandoffToken = async () => {
  const userId = localStorage.getItem("user_id");
  const { error, result } = await postApi("/auto_login_app_web", {
    module_id: EMPLOYEE_CONNECT_MODULE_ID,
    user_id: userId,
  });
  // Unlike the other three modules, module_id "20"'s response wraps the user
  // record in an array (`result.result: [{...}]`) rather than a single
  // object — confirmed from a live network trace.
  const handoffToken = result?.result?.[0]?.token_id;
  if (error || !handoffToken) {
    throw new Error("Could not obtain an Employee Connect handoff token from MyM.");
  }
  return handoffToken;
};

const exchangeToken = async () => {
  const tokenId = await getHandoffToken();
  return { tokenId, clientId: localStorage.getItem(CLIENT_ID) };
};

export const getEducationSession = () => {
  if (cachedSessionOwner !== currentSessionOwner()) {
    cachedSessionPromise = null;
    cachedSessionOwner = currentSessionOwner();
  }
  if (!cachedSessionPromise) {
    cachedSessionPromise = exchangeToken().catch((error) => {
      cachedSessionPromise = null; // let the next call retry instead of caching a failure
      throw error;
    });
  }
  return cachedSessionPromise;
};

// Same rationale as the other three modules — force a fresh exchange after a
// 401 rather than assume the user is unauthorized.
export const invalidateEducationSession = () => {
  cachedSessionPromise = null;
};
